export enum ServiceType {
  Examination = "examination",
  TestType = "testType",
  TestTypeCategory = "testTypeCategory",
  Survey = "survey",
}
